// extracted by mini-css-extract-plugin
export default {"container":"WishlistPage_container__9LdUA"};